<template>
  <v-dialog v-model="show" width="800" height="600">
    <v-card>
      <v-card-title>
        <span class="headline">Загрузка фото с камеры</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-layout row>
            <v-flex grow pa-2>
              <v-select
                :items="devices"
                :value="camera"
                item-value="deviceId"
                item-text="label"
                label="Активная камера"
                class="pl-4"
                outlined
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex grow pa-2>
              <vue-web-cam
                ref="webcam"
                :device-id="deviceId"
                @started="onStarted"
                @stopped="onStopped"
                @error="onError"
                @cameras="onCameras"
                @camera-change="onCameraChange"
              />
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex grow pa-2>
              <v-card-actions>
                <v-container fluid>
                  <v-row justify="center">
                    <v-btn
                      :disabled="img != null || streamAvailable == false"
                      class="ma-2 pa-6"
                      color="success"
                      @click="onCapture"
                      >Сделать фото</v-btn
                    >
                    <v-btn
                      :disabled="img == null"
                      class="ma-2 pa-6"
                      color="warning"
                      @click="onCancel"
                      >Отмена</v-btn
                    >

                    <v-btn
                      :disabled="img == null"
                      class="ma-2 pa-6"
                      color="success"
                      @click="onSavePhoto"
                      >Сохранить фото</v-btn
                    >
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { WebCam } from "vue-web-cam";

export default {
  name: "CameraDialog",

  props: ["visible"],

  components: {
    "vue-web-cam": WebCam,
  },
  data() {
    return {
      // value: false,
      img: null,
      camera: null,
      deviceId: null,
      devices: [],
      streamAvailable: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },

    device: function () {
      return this.devices.find((n) => n.deviceId === this.deviceId);
    },
  },
  watch: {
    visible: function () {
      this.img = null;
    },
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const devices = this.devices;
      if (devices[0]) {
        this.camera = devices[0].deviceId;
        this.deviceId = devices[0].deviceId;
      }
    },
  },
  methods: {
    onCapture() {
      this.img = this.$refs.webcam.capture();
      this.$refs.webcam.pause();
    },
    onStarted(/*stream*/) {
      this.streamAvailable = true;
    },
    onStopped(/*stream*/) {
      this.streamAvailable = false;
    },
    onStop() {
      this.$refs.webcam.stop();
    },
    onStart() {
      this.$refs.webcam.start();
    },
    onError(error) {
      this.$fire({
        text: error,
        type: "error",
      });
    },
    onCameras(cameras) {
      this.devices = cameras;
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
    },
    onSavePhoto() {
      if (this.img != null) {
        this.$emit("captured-camera-photo", this.img);
      }
      this.show = false;
    },
    onCancel() {
      this.$refs.webcam.resume();
      this.img = null;
    },
  },

  updated() {
    // для выхода из "паузы", когда обновляется(загружается) диалог

    if (this.show && this.img == null) {
      this.$refs.webcam.resume();
    }
  },
};
</script>